export const partnerFlagRequestTranslation = {
  notification: {
    requiredRoles: 'partnerflagrequest-notification-required_roles',
    requiredUsers: 'partnerflagrequest-notification-required_users',
    startDateMoreThanEndDate: 'partnerflagrequest-notification-start_date_more_than_end_date',
    startDateLessThanCurrentDate:
      'partnerflagrequest-notification-start_date_less_than_current_date',
    instruction: 'partnerflagrequest-notification-instruction',
    inactivePartnerFlag: 'partnerflagrequest-notification-inactive_partner_flag',
  },
  content: {
    title: 'partnerflagrequest-content-title',
    fields: {
      selector: 'partnerflagrequest-content-fields-selector',
      startDate: 'partnerflagrequest-content-fields-start_date',
      endDate: 'partnerflagrequest-content-fields-end_date',
    },
    buttons: {
      apply: 'partnerflagrequest-content-button-apply',
      reactivate: 'partnerflagrequest-content-button-reactivate',
      cancel: 'partnerflagrequest-content-button-cancel',
    },
  },
  confirm: {
    button: {
      confirm: 'partnerflagrequest-confirm-button-confirm',
      reject: 'partnerflagrequest-confirm-button-reject',
    },
    content: 'partnerflagrequest-confirm-content',
    title: 'partnerflagrequest-confirm-title',
  },
  warnings: {
    DSB: {
      title: 'partnerflagrequest-warnings-dsb-title',
      content: 'partnerflagrequest-warnings-dsb-content',
      confirmBtnText: 'partnerflagrequest-warnings-dsb-confirm_btn_text',
      cancelBtnText: 'partnerflagrequest-warnings-dsb-cancel_btn_text',
    },
  },
}
